// const API_BASE_URL = "http://localhost:5000";
const API_BASE_URL = "https://devapi.pretriptruck.com";
// const API_BASE_URL = "https://api.pretriptruck.com";

const AppConstants: any = {
  ADMIN_LOGIN_API: `${API_BASE_URL}/admin/login`,
  ADMIN_VERIFY_OTP_API: `${API_BASE_URL}/admin/verify-otp`,
  ADMIN_RESEND_OTP_API: `${API_BASE_URL}/admin/resend-otp`,
  ADMIN_PROFILE_API: `${API_BASE_URL}/admin/get-profile`,
  ADMIN_EDIT_PROFILE_API: `${API_BASE_URL}/admin/edit-profile`,
  ADMIN_CHANGE_PASSWORD_API: `${API_BASE_URL}/admin/change-password`,

  ADMIN_GET_PROMOCODES_API: `${API_BASE_URL}/promocodes`,
  ADMIN_GET_SINGLE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_CREATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_UPDATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_DELETE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,

  ADMIN_GET_PRICES_API: `${API_BASE_URL}/iap/pricing`,
  ADMIN_EDIT_PRICES_API: `${API_BASE_URL}/pricing/bulk`,

  ADMIN_GET_PLAN_DETAILS_API: `${API_BASE_URL}/plan-details`,
  ADMIN_POST_PLAN_DETAILS_API: `${API_BASE_URL}/plan-details/save`,

  ADMIN_USER_MANAGEMENT_API: `${API_BASE_URL}/user-management`,

  ADMIN_GET_ALL_PAYMENT_HISTORY: `${API_BASE_URL}/user-management/payment-transactions`,

  // Repair Shop Management APIs
  ADMIN_REPAIR_SHOPS_API: `${API_BASE_URL}/repair-shops/repair-shops-list`,
  ADMIN_CREATE_REPAIR_SHOP_API: `${API_BASE_URL}/repair-shops/create-repair-shop`,
  ADMIN_UPDATE_REPAIR_SHOP_API: `${API_BASE_URL}/repair-shops/edit-repair-shop`,
  ADMIN_DELETE_REPAIR_SHOP_API: `${API_BASE_URL}/repair-shops/delete-repair-shop`,
  ADMIN_REPAIR_SHOP_STATS_API: `${API_BASE_URL}/repair-shops/stats`,
  ADMIN_EXPORT_REPAIR_SHOPS_API: `${API_BASE_URL}/repair-shops/export-repair-shops`,

  // Service Management APIs
  ADMIN_SERVICES_API: `${API_BASE_URL}/services/list`,
  ADMIN_CREATE_SERVICE_API: `${API_BASE_URL}/services/create-service`,
  ADMIN_UPDATE_SERVICE_API: `${API_BASE_URL}/services/update-service`,
  ADMIN_DELETE_SERVICE_API: `${API_BASE_URL}/services/delete-service`,
  ADMIN_SERVICE_STATS_API: `${API_BASE_URL}/services/stats`,
  ADMIN_SERVICES_FOR_REPAIR_SHOP_API: `${API_BASE_URL}/services/services-for-repair-shop-list`,
  ADMIN_DASHBOARD: `${API_BASE_URL}`,

  // States API
  ADMIN_STATES_API: `${API_BASE_URL}/us/states`,
  STRIPE_PUBLISHABLE_KEY:
    (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string) ||
    "pk_test_51RdswjRvL1ddtGKxlTxApllEmzUlgfGZIcusIennvM1umXtsDdCKEz2C7JLsFIdx2X1xUhvDStSoKGfBuALU4i9000hbbrUV4s"
};

// Stripe/Payments endpoints used by the admin panel flows
// Adjust paths as needed to match your backend
AppConstants.PAYMENTS_SETUP_INTENT_API = `${API_BASE_URL}/payment-methods/setup-intent`;
// Prefer the consolidated payment-methods endpoint for saving
AppConstants.PAYMENTS_ADD_PAYMENT_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_LIST_METHODS_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_DELETE_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_SET_DEFAULT_METHOD_API = `${API_BASE_URL}/payment-methods/set-default`;
AppConstants.PAYMENTS_MAKE_PAYMENT_API = `${API_BASE_URL}/api/payments/make-payment`;
// Subscription endpoints
// AppConstants.SUBSCRIPTION_PREFILL_API = `${API_BASE_URL}/subscription/prefill`;
AppConstants.SUBSCRIPTION_CREATE_API = `${API_BASE_URL}/subscription`;
// Driver profile (to resolve customerId for subscription body)
AppConstants.DRIVER_PROFILE_API = `${API_BASE_URL}/profile`;

export default AppConstants;
